import React, { Component } from "react";
import Constants from "utils/Constants";
import HelperFunctions from "common/HelperFunctions";
import OrderTabRenderingHandler from "order/OrderTabRenderingHandler";

/**
 * OrderBusinessDeveloperTab is used to display all of the stages that a business operator works through in an order
 */
class OrderBusinessDeveloperTab extends Component {
    state = {
        isUpdateOrderBusinessDeveloperTabInProgress: false
    };

    componentDidMount = () => {
        if (!this.props.auth.isUserSignedIn() || !this.props.auth.getSignInUserSession().isValid()) {
            HelperFunctions.displayFlashbarError(this, new Error(Constants.FLASHBAR_STRINGS.flashbarMidwayError),
                { loading: false });
        }
    };

    handleStageInEditOrSubmitMode = (isBeingEditedOrSubmitted) => {
        this.props.setIsAnyEditModeEnabled(isBeingEditedOrSubmitted);
    };

    render() {
        return (
            <OrderTabRenderingHandler
                asn={this.props.asn}
                asnLoading={this.props.asnLoading}
                order={this.props.order}
                circuitDesignObjects={this.props.circuitDesignObjects}
                circuitDesignsLoading={this.props.circuitDesignsLoading}
                componentIdToObjectMap={this.props.componentIdToObjectMap}
                loadingComponentIdToObjectMap={this.props.loadingComponentIdToObjectMap}
                siteNames={this.props.siteNames}
                loadData={this.props.loadData}
                handleFlashBarMessagesFromChildTabs={this.props.handleFlashBarMessagesFromChildTabs}
                stages={this.props.stages}
                orderCompleted={this.props.orderCompleted}
                goToComponentAction={this.props.goToComponentAction}
                isUpdateOrderBusinessDeveloperTabInProgress={this.state.isUpdateOrderBusinessDeveloperTabInProgress}
                auth={this.props.auth}
                blockers={this.props.blockers}
                showAttachmentModal={this.props.showAttachmentModal}
                attachmentsLoading={this.props.attachmentsLoading}
                downloadAttachment={this.props.downloadAttachment}
                isDownloadingAttachment={this.props.isDownloadingAttachment}
                editButtonsDisabled={this.props.isAnyEditModeEnabled || !this.props.isTabEditable}
                user={this.props.user}
                handleStageInEditOrSubmitMode={this.handleStageInEditOrSubmitMode}
                isDataLoaded={this.props.isDataLoaded}
                showTemplateGeneratorModal={this.props.showTemplateGeneratorModal}
                workOrder={this.props.workOrder}
                span={this.props.span}
                siteOptions={this.props.siteOptions}
                fetchSiteOptions={this.props.fetchSiteOptions}
                setIsAnyEditModeEnabled={this.props.setIsAnyEditModeEnabled}
                handleToggleCompleteStage={this.props.handleToggleCompleteStage}
            />
        );
    }
}

export default OrderBusinessDeveloperTab;